module.exports = __webpack_public_path__ + "static/media/collector_grey.d0003e30.png";